<template>
  <div>
    <CrudList
      title="Ayuda"
      storeName="Helps"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/faqs"
      :breadcrumbs="[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/helps'
        },
        {
          text: 'Ayuda',
          disabled: false,
          href: '#'
        },
        
      ]"
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
